import { FC } from "react";
import { NetworkPortfolioManagementResourceView } from "@app/network-portfolio-management/interfaces";
import { useNPMView } from "@app/network-portfolio-management/hooks/useNPMView";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

// View-scope toggles for the NPM dashboard
export const ViewToggles: FC = () => {
  const { getCurrentNpmView, canAccessNpmView, setNpmView } = useNPMView();
  const view = getCurrentNpmView();

  switch (view) {
    case NetworkPortfolioManagementResourceView.Active:
      return (
        <span className="btn-group network-portfolio-management-view-toggles">
          {canAccessNpmView(NetworkPortfolioManagementResourceView.Archived) && (
            <QESButton
              qesType="link"
              qesTestId="network-portfolio-management-archive-toggle"
              onClick={() => setNpmView(NetworkPortfolioManagementResourceView.Archived)}
            >
              <QesIcon iconName={QesIcons.Archive} isDecorative className="me-1" />
              View Archived
            </QESButton>
          )}
          <QESButton
            qesType="link"
            qesTestId="network-portfolio-management-hidden-toggle"
            onClick={() => setNpmView(NetworkPortfolioManagementResourceView.Hidden)}
          >
            <QesIcon iconName={QesIcons.EyeOff} isDecorative className="me-1" />
            View Hidden
          </QESButton>
        </span>
      );

    case NetworkPortfolioManagementResourceView.Archived:
    case NetworkPortfolioManagementResourceView.Hidden:
      return (
        <span className="btn-group network-portfolio-management-view-toggles">
          <QESButton
            qesType="link"
            qesTestId="network-portfolio-management-active-toggle"
            onClick={() => setNpmView(NetworkPortfolioManagementResourceView.Active)}
          >
            <QesIcon iconName={QesIcons.Eye} isDecorative className="me-1" />
            View Active
          </QESButton>
        </span>
      );

    default:
      return null;
  }
};
